<template>
  <div class="dloons">
    <img src="@/assets/promo/dloons_promo.png" alt="Doubloons" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-Doub-Loons/dp/B008NX8S2I/ref=sr_1_9?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-9">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Save Your Pirate Booty!</h2>
    <br>
    <p class="app-blurb">Your booty is booby trapped. Find the matching doubloons to save your treasure from the hiden bombs.
      Keep your wits or watch it all go up in smoke.
    </p>
    <br><br>
    <img src="@/assets/screenshots/dloons_01.png" alt="">
    <img src="@/assets/screenshots/dloons_02.png" alt="">
    <img src="@/assets/screenshots/dloons_03.png" alt="">
    <img src="@/assets/screenshots/dloons_04.png" alt="">
    <img src="@/assets/screenshots/dloons_05.png" alt="">
    <img src="@/assets/screenshots/dloons_06.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'dloons',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.dloons {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.dloons img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 60%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
